// This file configures the initialization of Sentry and PostHog on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/blog/:slug\",\"regex\":\"^/blog/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/:slug\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/blog\"},{\"path\":\"/privacy\"},{\"path\":\"/about\"},{\"path\":\"/terms\"},{\"path\":\"/contact\"},{\"path\":\"/admin\"},{\"path\":\"/routes\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.9";import * as Sentry from "@sentry/nextjs";
import posthog from "posthog-js";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN || "https://618f9b4b14e01fa9ce0c9e8ce07774c6@o4511635161415680.ingest.de.sentry.io/4511635180486736",

  // Session Replay is lazy-loaded below (see loadReplay) so its ~200KB stays
  // out of the initial bundle. Error tracking + tracing remain in-bundle.
  integrations: [],

  // Explicitly tag the execution environment (e.g. 'development', 'production')
  environment: process.env.NODE_ENV,

  // 100% in development for testing, 10% in production to stay within free quotas
  tracesSampleRate: process.env.NODE_ENV === "development" ? 1.0 : 0.1,

  // Enable logs to be sent to Sentry
  enableLogs: true,

  // 100% replay capture in development, 10% in production
  replaysSessionSampleRate: process.env.NODE_ENV === "development" ? 1.0 : 0.1,

  // Always capture 100% of sessions when an error is thrown
  replaysOnErrorSampleRate: 1.0,

  // Enable sending user PII (Personally Identifiable Information)
  sendDefaultPii: true,
});

// Lazy-load Session Replay from Sentry's CDN after the page is idle, keeping
// the ~200KB integration out of the initial JS bundle. The sample rates set
// in Sentry.init above still apply once it's added.
// IMPORTANT: the deployment CSP must allow the CDN host in script-src:
//   https://browser.sentry-cdn.com (and https://js.sentry-cdn.com)
// otherwise this load is blocked and Replay silently stays off.
if (typeof window !== "undefined") {
  const loadReplay = async () => {
    try {
      const replayIntegration = await Sentry.lazyLoadIntegration("replayIntegration");
      Sentry.addIntegration(replayIntegration({ maskAllText: false, blockAllMedia: false }));
    } catch {
      // Replay is optional — ignore network/CSP failures.
    }
  };
  const w = window as Window & { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => void };
  if (typeof w.requestIdleCallback === "function") {
    w.requestIdleCallback(() => void loadReplay(), { timeout: 5000 });
  } else {
    setTimeout(() => void loadReplay(), 3000);
  }
}

if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: "/ingest",
    ui_host: "https://eu.posthog.com",
    defaults: "2026-01-30",
    capture_exceptions: true,
    debug: process.env.NODE_ENV === "development",
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
